module.exports = ".single-data-label {\n  font-size: 14px;\n  font-family: \"Open Sans\", \"sans-serif\";\n  color: #292929;\n  background-color: transparent; }\n\n.single-data-value {\n  font-size: 14px;\n  font-family: \"Open Sans\", \"sans-serif\";\n  font-weight: bold;\n  color: #292929;\n  background-color: transparent; }\n\ntextarea {\n  resize: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/report-header/report-header.component.scss
// module id = ./src/app/components/report-header/report-header.component.scss
// module chunks = main